import { Component, Input } from '@angular/core';
import { defaultTheme } from 'src/app/theme/theme';
import { Topic } from '../topic';

@Component({
    selector: 'app-forum-topic-title',
    templateUrl: './forum-topic-title.component.html',
    styleUrls: ['./forum-topic-title.component.scss'],
    standalone: false
})
export class ForumTopicTitleComponent {
  @Input()
  theme = defaultTheme;

  @Input()
  topic: Topic;

  @Input()
  hasLine: boolean;

  get titleStyle() {
    return {
      color: this.theme.primaryDarkColor
    };
  }

  get containerBoxStyle() {
    return {
      'border-bottom': `2px solid  ${this.theme.primaryLightColor}`
    };
  }

  get topicUrl(): string {
    return '/forum/topic/' + this.topic.id;
  }
}
